import { render, staticRenderFns } from "./StartupsLocationChart.vue?vue&type=template&id=6f040028&"
import script from "./StartupsLocationChart.vue?vue&type=script&lang=js&"
export * from "./StartupsLocationChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports